<h4><u>Quote Details</u></h4>
<div class="row">
  <div class="col-md-7">
    <div class="row mb-3">
      <div class="col-md-6"><label>Cover From:</label></div>
      <div class="col-md-6">
        <input type="text" name="cover_from" [value]="cover_from | date:'dd-MM-yyyy'"
               class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Cover To:</label></div>
      <div class="col-md-6">
        <input type="text" name="cover_to" [value]="cover_to | date:'dd-MM-yyyy'"
               class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Product:</label></div>
      <div class="col-md-6">
        <input 
          readonly  
          type="text" 
          name="product" 
          value="Horsebox Breakdown" 
          class="form-control form-control-sm"
        >
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Broker:</label></div>
      <div class="col-md-6">
        <input 
          readonly
          type="text" 
          name="broker" 
          [value]="brokerName"
          class="form-control form-control-sm"
        >
      </div>
    </div>
    <div class="row mb-3" *ngIf="quote && quote?.type == 3">
      <div class="col-md-6"><label>Effective Date:</label></div>
      <div class="col-md-6">
        <input type="text" name="cover_from" [value]="quote?.effective_date | date:'dd-MM-yyyy'"
               class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Transaction Date:</label></div>
      <div class="col-md-6" *ngIf="quote">
        <input type="text" name="transactional_date" [value]="quote?.transactional_date | date:'dd-MM-yyyy'"
               class="form-control form-control-sm" readonly>
      </div>
      <div class="col-md-6" *ngIf="!quote">
        <input type="text" name="transactional_date" [value]=""
               class="form-control form-control-sm" readonly>
      </div>
    </div>
  </div>
</div>

<h4><u>Proposer Details</u></h4>
<div class="row">
  <div class="col-md-7">
    <div class="row mb-3">
      <div class="col-md-6"><label>Customer type:</label></div>
      <div class="col-md-6">
        <input 
          readonly
          type="text" 
          name="proposer_type"
          [value]="getProposerType() | titlecase"
          class="form-control form-control-sm" 
        >
      </div>
    </div>
    <!--- Company / Joint Details   -->
    <div
      *ngIf="quote?.policy_holder_detail?.proposer_type == 'company' || quote?.policy_holder_detail?.proposer_type == 'joint'">
      <div class="row mb-3" *ngIf="quote?.policy_holder_detail?.proposer_type == 'company'">
        <div class="col-md-6"><label>Is this client a Micro-enterprise?</label></div>
        <div class="col-md-6">
          <mat-radio-group class="row" aria-label="Select an option" name="is_micro_enterprise" disabled>
            <div class="col-md-6">
              <div class="quote_radio">
                <mat-radio-button 
                  value="1"
                  [checked]="isMicroEnterpriseYes()"
                >
                    Yes
                </mat-radio-button>
              </div>
            </div>
            <div class="col-md-6">
              <div class="quote_radio">
                <mat-radio-button 
                  value="2"
                  [checked]="!isMicroEnterpriseYes()"
                >
                  No
                </mat-radio-button>
              </div>
            </div>
          </mat-radio-group>
        </div>
      </div>
      <div class="row mb-3" *ngIf="quote?.policy_holder_detail?.proposer_type == 'joint'">
        <div class="col-md-6"><label>Names:</label></div>
        <div class="col-md-6">
          <input 
            readonly
            type="text" 
            name="joint_names"
            [value]="quote?.policy_holder_detail.company_name | titlecase"
            class="form-control form-control-sm" 
          >
        </div>
      </div>
      <div class="row mb-3" *ngIf="quote?.policy_holder_detail?.proposer_type == 'company'">
        <div class="col-md-6">
          <label>Company Name:</label>
        </div>
        <div class="col-md-6">
          <input 
            readonly
            type="text" 
            name="company_name"
            [value]="quote?.policy_holder_detail.company_name | titlecase"
            class="form-control form-control-sm" 
          >
        </div>
      </div>
    </div>

    <!--- Individual Details -->
    <div>
      <div class="row mb-3" *ngIf="quote?.policy_holder_detail?.proposer_type == 'individual'">
        <div class="col-md-6"><label>Title:</label></div>
        <div class="col-md-6">
          <input 
            type="text" 
            name="title" 
            [value]="quote?.policy_holder_detail.title | titlecase"
            class="form-control form-control-sm" 
            readonly
          >
        </div>
      </div>
      <div class="row mb-3" *ngIf="quote?.policy_holder_detail?.proposer_type == 'individual'">
        <div class="col-md-6"><label>First Name:</label></div>
        <div class="col-md-6">
          <input 
            type="text" 
            name="first_name" 
            [value]="quote?.policy_holder_detail.first_name | titlecase"
            class="form-control form-control-sm" 
            readonly
          >
        </div>
      </div>
      <div class="row mb-3" *ngIf="quote?.policy_holder_detail?.proposer_type == 'individual'">
        <div class="col-md-6"><label>Last Name:</label></div>
        <div class="col-md-6">
          <input 
            type="text" 
            name="last_name" 
            [value]="quote?.policy_holder_detail.last_name | titlecase"
            class="form-control form-control-sm" 
            readonly
          >
        </div>
      </div>
      <div class="row mb-3" *ngIf="quote?.policy_holder_detail?.proposer_type == 'individual'">
        <div class="col-md-6"><label>Date Of Birth:</label></div>
        <div class="col-md-6">
          <input 
            type="text" 
            name="dob" 
            [value]="quote?.policy_holder_detail.dob"
            class="form-control form-control-sm" 
            readonly
          >
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6"><label>Email:</label></div>
        <div class="col-md-6">
          <input 
            type="text" 
            name="email" 
            [value]="quote.policy_holder_detail.email"
            class="form-control form-control-sm" 
            readonly
          >
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6"><label>Phone Number:</label></div>
        <div class="col-md-6">
          <input 
            type="text" 
            name="phone" 
            [value]="quote.policy_holder_detail.phone"
            class="form-control form-control-sm" 
            readonly
          >
        </div>
      </div>
    </div>

    <!--  Address Details -->
    <h6><u>Address Details</u></h6>
    <div class="row mb-3">
      <div class="col-md-6"><label>Address Line 1:</label></div>
      <div class="col-md-6">
        <input 
          readonly
          type="text" 
          name="line1" 
          [value]="quote?.policy_holder_detail.address.address1"
          class="form-control form-control-sm"
          readonly
        >
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Address Line 2:</label></div>
      <div class="col-md-6">
        <input type="text" name="line2" [value]="quote?.policy_holder_detail.address.address2"
               class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Address Line 3:</label></div>
      <div class="col-md-6">
        <input type="text" name="line3" [value]="quote?.policy_holder_detail.address.address3"
               class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>County:</label></div>
      <div class="col-md-6">
        <input type="text" name="county" [value]="quote?.policy_holder_detail.address.city"
               class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Postcode:</label></div>
      <div class="col-md-6">
        <input type="text" name="postcode" [value]="quote?.policy_holder_detail.address.postcode"
               class="form-control form-control-sm" readonly>
      </div>
    </div>
  </div>
</div>

<div *ngIf="quote?.policy_holder_detail.claims && quote?.policy_holder_detail.claims.length > 0">
  <h4><u>Claims</u></h4>
  <div class="row">
    <div class="col-md-7">
      <div *ngFor="let clm of quote?.policy_holder_detail.claims; let i = index;">
        <h6><u>Claims {{ i + 1 }}</u></h6>
        <div class="row mb-3">
          <div class="col-md-6"><label>Date of claim:</label></div>
          <div class="col-md-6">
            <input type="text" name="claim_date_{{i}}" [value]="clm.date | date:'dd-MM-yyyy'"
                   class="form-control form-control-sm" readonly>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6"><label>Type of incident:</label></div>
          <div class="col-md-6">
            <input type="text" name="incident_type_{{i}}" [value]="clm.type"
                   class="form-control form-control-sm" readonly>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6"><label>AD claim cost:</label></div>
          <div class="col-md-6">
            <input type="text" name="ad_cost_{{i}}" [value]="clm.ad_cost | number: '1.2-2'"
                   class="form-control form-control-sm" readonly>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6"><label>TP claim cost:</label></div>
          <div class="col-md-6">
            <input type="text" name="tp_cost_{{i}}" [value]="clm.tp_cost | number: '1.2-2'"
                   class="form-control form-control-sm" readonly>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6"><label>Total claim cost:</label></div>
          <div class="col-md-6">
            <input type="text" name="total_{{i}}" [value]="(clm.ad_cost + clm.tp_cost) | number: '1.2-2'"
                   class="form-control form-control-sm" readonly>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6"><label>Was the driver at fault?:</label></div>
          <div class="col-md-6">
            <mat-radio-group class="row" aria-label="Select an option" disabled name="fault_{{i}}">
              <div class="col-md-4">
                <div class="quote_radio w-90">
                  <mat-radio-button value="true" [checked]="clm.fault">Yes</mat-radio-button>
                </div>
              </div>
              <div class="col-md-4">
                <div class="quote_radio w-90">
                  <mat-radio-button value="false" [checked]="!clm.fault">No</mat-radio-button>
                </div>
              </div>
            </mat-radio-group>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6"><label>Is the claim still open?:</label></div>
          <div class="col-md-6">
            <mat-radio-group class="row" aria-label="Select an option" disabled name="open_{{i}}">
              <div class="col-md-4">
                <div class="quote_radio w-90">
                  <mat-radio-button value="true" [checked]="clm.open">Yes</mat-radio-button>
                </div>
              </div>
              <div class="col-md-4">
                <div class="quote_radio w-90">
                  <mat-radio-button value="false" [checked]="!clm.open">No</mat-radio-button>
                </div>
              </div>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="quote && quote?.is_send_email == 1">
  <h4><u>Contact Details</u></h4>
  <div class="row">
    <div class="col-md-7">
      <div class="row mb-3">
        <div class="col-md-6"><label>Email: </label></div>
        <div class="col-md-6">
          <input type="text" name="email" [value]="quote?.email" class="form-control form-control-sm" readonly>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6"><label>Phone: </label></div>
        <div class="col-md-6">
          <input type="text" name="phone" [value]="quote?.phone" class="form-control form-control-sm" readonly>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6"><label>Preferred ways to hear:</label></div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-3">
              <mat-radio-group class="row" aria-label="Select an option" name="is_phone" disabled>
                <div class="quote_radio">
                  <mat-radio-button value="1" [checked]="quote?.is_phone == 1">Phone</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
            <div class="col-md-3">
              <mat-radio-group class="row" aria-label="Select an option" name="sms" disabled>
                <div class="quote_radio">
                  <mat-radio-button value="1" [checked]="quote?.sms == 1">Text</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
            <div class="col-md-3">
              <mat-radio-group class="row" aria-label="Select an option" name="is_email" disabled>
                <div class="quote_radio">
                  <mat-radio-button value="1" [checked]="quote?.is_email == 1">Email</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
            <div class="col-md-3">
              <mat-radio-group class="row" aria-label="Select an option" name="post" disabled>
                <div class="quote_radio">
                  <mat-radio-button value="1" [checked]="quote?.post == 1">Post</mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>


